import React from 'react';
import PropTypes from 'prop-types';

import ZpFilter from '../zpFilter';
import { CAROUSEL_FILTERS, FILTER_PARAMS } from '../zpFilter/filterUtils';

export default function LocationFilter(props) {
  const {
    title,
    enableFilter,
    onFilterClear,
    noLocationFilter,
    onUpdateFilter,
    preselectedItems = [],
  } = props;

  const setupFilter = () => ({
    ...CAROUSEL_FILTERS[FILTER_PARAMS.LOCATION],
    options: {
      autoSuggest: true,
      limit: 3,
      remote: false,
    },
    preselectedItems,
  });

  return enableFilter ? (
    <>
      <p dangerouslySetInnerHTML={{ __html: title }} className="z-mb-24" />
      {!noLocationFilter && (
        <ZpFilter {...setupFilter()} onApply={onUpdateFilter} onClear={onFilterClear} />
      )}
      <div className="component-separator" />
    </>
  ) : null;
}

LocationFilter.propTypes = {
  title: PropTypes.string,
  enableFilter: PropTypes.bool,
  onFilterClear: PropTypes.func,
  onUpdateFilter: PropTypes.func,
};
